import { IconButton } from '@mui/material';
import {
  FaArrowLeftLightSvgIcon,
  FaXMarkLightSvgIcon,
} from '../../../assets/icons/svgs';
import { colors } from '../../../theme/colors';
import spacing, { isMobileScreen } from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import { TOP_MENU_BAR_HEIGHT } from '../../TopMenuBar.tsx/constants';
import { drawerFullHeightBackgroundColor } from '../utils';

const CloseModalButton = ({ onModalClose }: { onModalClose?: () => void }) => {
  if (!onModalClose || !isMobileScreen) {
    return null;
  }

  return (
    <IconButton
      onClick={onModalClose}
      style={{
        padding: spacing.medium,
      }}
    >
      <FaXMarkLightSvgIcon
        size={fontSize['2xl'] + 4}
        fill={colors.textPrimary}
      />
    </IconButton>
  );
};

const ModalTitleBarWithSideButtons = ({
  title,
  onModalClose,
  LeftSideActionComponent,
  RightSideActionComponent,
  titleStyles,
  smallFontOnMobile,
  onBackClick,
}: {
  title?: string;
  onModalClose?: () => void;
  onBackClick?: () => void;
  LeftSideActionComponent?: React.ReactNode;
  RightSideActionComponent?: React.ReactNode;
  titleStyles?: React.CSSProperties;
  smallFontOnMobile?: boolean;
}) => {
  const LeftSideButton = () => {
    if (onBackClick) {
      return (
        <IconButton
          onClick={onBackClick}
          style={{
            padding: spacing.medium,
          }}
        >
          <FaArrowLeftLightSvgIcon
            size={fontSize['2xl']}
            fill={colors.textPrimary}
          />
        </IconButton>
      );
    }

    if (!LeftSideActionComponent) {
      return null;
    }

    return <>{LeftSideActionComponent}</>;
  };

  const RightSideButton = () => {
    if (onModalClose) {
      return <CloseModalButton onModalClose={onModalClose} />;
    }

    if (RightSideActionComponent) {
      return <>{RightSideActionComponent}</>;
    }

    return null;
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'center',
        height: TOP_MENU_BAR_HEIGHT,
        maxHeight: TOP_MENU_BAR_HEIGHT,
        minHeight: TOP_MENU_BAR_HEIGHT,
        background: drawerFullHeightBackgroundColor,
      }}
    >
      <div style={{ position: 'absolute', left: 0 }}>
        <LeftSideButton />
      </div>
      <div
        style={{
          textAlign: 'center',
          fontSize: smallFontOnMobile ? fontSize.lg : fontSize.xl,
          color: colors.textPrimary,
          fontWeight: '500',
          ...titleStyles,
        }}
      >
        {title || ''}
      </div>
      <div style={{ position: 'absolute', right: 0 }}>
        <RightSideButton />
      </div>
    </div>
  );
};

export default ModalTitleBarWithSideButtons;
